import { Layout } from 'antd'
import React from 'react'
import RegistrationForm from '../../components/Client/RegistrationForm'

const ClientRegister = () => {
    return (
        <Layout>
            <Layout.Content>
                <RegistrationForm/>
            </Layout.Content>
        </Layout>
    )
}

export default ClientRegister
